import React, { useState } from "react";
import { useTrans, useEventListener } from "../hooks";
import PropTypes from "prop-types";
import { getStorageItem } from "../helpers";

let window = window || global;

// This button lets users create/edit a story cover in Canva.
function CanvaButton({ story, onOpenCanva }) {
  const { trans } = useTrans();
  const [overrideStory, setOverrideStory] = useState(null);

  useEventListener(
    "myworks:cover:saved",
    event => {
      setOverrideStory(event.detail);
    },
    window
  );

  // Get canva id from either the server or stored in the user's cookies
  // TODO: re-evaluate this logic, is canva id stored in cookies still needed? can we just use the server value?
  const getCanvaId = () => {
    let designId = null;
    if (story.id) {
      if (overrideStory) {
        // This override story is to refresh the updated cover_source_id when a new cover is uploaded
        if (
          overrideStory.cover_partner === "canva" &&
          overrideStory.cover_source_id
        ) {
          designId = overrideStory.cover_source_id;
        }
      } else {
        if (story.cover_partner === "canva" && story.cover_source_id) {
          designId = story.cover_source_id;
        } else {
          designId = getStorageItem({ key: `canva-cover-${story.id}` });
        }
      }
    }
    return designId;
  };

  return (
    <button
      className="canva-btn canva-btn-size-s"
      onClick={() => onOpenCanva(getCanvaId())}
      disabled={!window.wattpad?.testGroups?.IS_CANVA_POC}
    >
      <span className="canva-btn-i" />
      {getCanvaId() ? trans("Edit Cover") : trans("Create Cover")}
    </button>
  );
}

CanvaButton.propTypes = {
  story: PropTypes.object,
  onOpenCanva: PropTypes.func
};

export { CanvaButton };
